import { render, staticRenderFns } from "./indexShop.vue?vue&type=template&id=521fb315"
import script from "./indexShop.vue?vue&type=script&lang=js"
export * from "./indexShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports